import { RunesTemplate } from '@/components/templates/Runes'
import { useAppModal, AppModals } from '@/context/ModalProvider'
import { useMaintenance } from '@/hooks/useMaintenance'
import { useEffect } from 'react'

const RunesPage = () => {
  const { isMaintenance } = useMaintenance()
  const modal = useAppModal()

  useEffect(() => {
    if (isMaintenance) {
      modal.openModalNew(AppModals.MaintenanceModal)
    }
  }, [])

  return <RunesTemplate />
}

export default RunesPage
